var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',{class:_vm.$style.container},[_c('img',{attrs:{"src":_vm.photoUrl,"alt":_vm.name}}),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.phoneNumber.nationalNumber))])]),_vm._v(" "),_c('ContactButtons',{class:_vm.$style.actions,attrs:{"contact":_vm.contact,"phone":_vm.phoneNumber,"hasSmsButton":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86a095a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sms/contact/contact.vue
// module id = BW93
// module chunks = 1